/**
 * Interface representing the subtype of a person in the Substrate Search Service (3S).
 */ export var SubstratePeopleSubtype = /*#__PURE__*/ function(SubstratePeopleSubtype) {
    /** A user who is a guest in the system. */ SubstratePeopleSubtype["Guest"] = "Guest";
    /** A user that belongs to the organization */ SubstratePeopleSubtype["OrganizationUser"] = "OrganizationUser";
    return SubstratePeopleSubtype;
}({});
